import React from 'react';

require('../../css/components/Breadcrumbs.scss');

'use strict';

export default class Breadcrumbs extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return <nav className="navbar breadcrumbs">
            {
                this.props.breadcrumbs.map((breadcrumb) => {
                    let className = '';
                    if (breadcrumb.label === '/')
                        className = 'separator ';

                    if (breadcrumb.url)
                        return (
                            <div className = { className + 'navbar-nav' } key = { breadcrumb.key }>
                                <a className="nav-link" href={breadcrumb.url}>{breadcrumb.label}</a>
                            </div>
                            )
                    else {
                        return <span className={className + 'navbar-text'} key={breadcrumb.key}>{breadcrumb.label}</span>
                    }
                })
            }
        </nav>
    }
}
